import { PenTool, Calendar, Type } from 'lucide-react';

/**
 * Shared signature-feature helpers used by both the SignaturesHub page and
 * its extracted child components. Centralised here so a tweak to default
 * field sizing or PDF-bytes encoding flows through everywhere.
 */

export const FIELD_TYPES = [
  { id: 'signature', label: 'Signature', icon: PenTool, defaultW: 0.22, defaultH: 0.06 },
  { id: 'date', label: 'Date', icon: Calendar, defaultW: 0.14, defaultH: 0.035 },
  { id: 'text', label: 'Text', icon: Type, defaultW: 0.22, defaultH: 0.035 },
];

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}
